import { Component, inject, input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IStepTracker } from '@core/interface';
import { TranslateModule } from '@ngx-translate/core';
import { isSourceFordPass, isSourcePerks } from '@core/utils';
import { SessionService } from '@agenda-customer-ui/data-access';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-ui-tracker',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './tracker.component.html',
  styleUrls: ['./tracker.component.scss'],
})
export class TrackerComponent implements OnInit {
  readonly #sessionService = inject(SessionService);
  listOfSteps = input.required<IStepTracker[]>();
  isFordpass = false;

  ngOnInit(): void {
    const source = this.#sessionService.getItem('source');
    this.isFordpass = isSourceFordPass(source) || isSourcePerks(source);
  }
}
